import MDAlert from "components/MDAlert";
import DataTable from "components/Tables/DataTable/DataTable";
import TableSkeleton from "components/TableSkeleton/TableSkeleton";
import usePlantsTable from "hooks/organization/plants/usePlantsTable";

export default function Index() {
  const { loading, error, tableData, pagination, filtering } = usePlantsTable();

  return (
    <>
      {(loading || error) && (
        <div style={{ padding: "16px" }}>
          {loading && <TableSkeleton numberOfLines={pagination.pageSize} />}
          {error && <MDAlert color="error">{error.message}</MDAlert>}
        </div>
      )}
      {!loading && !error && tableData?.rows?.length > 0 && (
        <DataTable table={tableData} canSearch pagination={pagination} filtering={filtering} />
      )}
    </>
  );
}
